import { Component, computed, input, output } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { Product } from '@zayan-erp/home-building';

@Component({
  selector: 'lib-product-preview-card',
  imports: [TableModule],
  templateUrl: './product-preview-card.component.html',
  standalone: true
})
export class ProductPreviewCardComponent {
  product = input<Product | null>(null);
  showCheckbox = input<boolean | null>(null);
  productSelected = output<Product>();
  computedProduct = computed(() => this.product());
}
